module.exports = require("@jswork/next-css-text");